import { useContext, useEffect, useState } from "react";

import { AppContext } from "../../context/AppContext";

const useBridgeFlow = () => {
  const { transferFlow } = useContext(AppContext);

  const [isReady, setIsReady] = useState<boolean>(false);

  useEffect(() => {
    if (!transferFlow) {
      return;
    } else {
      setIsReady(true);
    }
  }, [transferFlow]);

  return {
    isReady,
  };
};

export default useBridgeFlow;
